import { createContext } from 'react';
import { ModalContextT } from './modal-provider/types';
import { HighlightContextT } from './highlight-provider/types';

export const ModalContext = createContext<ModalContextT | null>(null);

export const HighlightContext = createContext<HighlightContextT | null>(null);
